import * as amplitude from "@amplitude/analytics-browser";
import { AMPLITUDE_API_KEY } from "../../config";
import { EVENTS } from "./events";
import type { AnalyticsEventKey, AnalyticsEventProperties } from "./types";

class Analytics {
  private _enabled: boolean;

  constructor() {
    this._enabled = import.meta.env.PROD && !!AMPLITUDE_API_KEY;

    if (this._enabled) {
      amplitude.init(AMPLITUDE_API_KEY, {
        defaultTracking: {
          attribution: false,
          pageViews: false,
          sessions: false,
          formInteractions: false,
          fileDownloads: false,
        },
      });
    }
  }

  private _logEvent(name: string, properties?: Record<string, string>) {
    if (!this._enabled) return;

    amplitude.track(
      name,
      {
        ...properties,
      },
      {
        time: Date.now(),
      },
    );
  }

  log<T extends AnalyticsEventKey>(
    eventKey: T,
    properties?: AnalyticsEventProperties<T>,
  ) {
    const event = EVENTS[eventKey];

    if ("properties" in event && !properties) {
      throw new Error(`Properties are required for event: ${eventKey}`);
    }

    this._logEvent(event.name, properties);
  }
}

export const analytics = new Analytics();
